import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext.jsx';
import GlobalStyles from './styles/GlobalStyles';
import Navbar from './components/Navbar';
import Loader from './components/Loader';

// Lazy load components
const Hero = lazy(() => import('./components/Hero.jsx'));
const FunFact = lazy(() => import('./components/FunFact.jsx'));
const About = lazy(() => import('./components/AboutUS.jsx'));
const Skills = lazy(() => import('./components/Skills.jsx'));
const Services = lazy(() => import('./components/Services.jsx'));
const Experience = lazy(() => import('./components/Resume.jsx'));
const Projects = lazy(() => import('./components/Portifolio.jsx'));
const ProjectDetails = lazy(() => import('./components//ProjectDetails.jsx'));
const NotFound = lazy(() => import('./components/NotFound.jsx'));
// const Testimonials=lazy(()=>import('./components/Testimonials'));
const Footer=lazy(()=>import('./components/Footer.jsx'))
const ContactUs=lazy(()=>import('./components/ContactUs.jsx'))
// const projectsData = React.lazy(() => import('./components/projectsData.js'));
// Home component to organize main page sections
const Home = () => (
  <>
    <Hero />
    <FunFact />
    <About />
    <Skills />
    <Services />
    <Experience />
    <Projects />
    {/* <Testimonials/> */}
    <ContactUs/>
    {/* <Footer/> */}
  </>
);

// MainLayout component with scroll restoration
const MainLayout = ({ children }) => {
  React.useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      {children}
      <Footer/>
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <GlobalStyles />
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Main route */}
          <Route
            path="/"
            element={
              <MainLayout>
                <Home />
              </MainLayout>
            }
          />
          
          {/* Portfolio detail route */}
          <Route
            path="/portifolio/:id"
            element={
              <MainLayout>
                <Suspense fallback={<Loader />}>
                  <ProjectDetails />
                </Suspense>
              </MainLayout>
            }
          />

          {/* 404 and redirect routes */}
          <Route 
            path="/404" 
            element={
              <MainLayout>
                <NotFound />
              </MainLayout>
            } 
          />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;